export default class Role {

  constructor( api, id ) {
    this.api = api.child( `role/${id}` )
  }

  get( opts ) {
    return this.api.get( opts )
  }

  update( update ) {
    return this.api.patchRaw( update )
  }

  delete( ) {
    return this.api.delete( )
  }

  addPermission( permission ) { 
    return this.api.child( 'permission' ).post( permission )
  }

  addPermissions( permissions ) {
    return this.api.child( 'permission' ).post( permissions ) 
  }

  setPermissions( permissions ) {
    return this.api.child( 'permission' ).post( { set : true, permissions } ) 
  }

  removePermission( id ) { 
    return this.api.child( `permission/${id}` ).delete( ) 
  }

  /**
   * @param {array<string>} ids the ids to remove
   */
  removePermissions( ids ) { 
    return this.api.child( 'permission' ).delete( { id : ids } ) 
  }

  permissions( options ) {
    return this.api.child( 'permission' ).get( options ) 
  }

}
